/**
 * CollapsiblePanel — 左侧 Navy 折叠面板（共享组件）
 *
 * 320px / 48px 可折叠侧边栏，用于 ClientDetail / ContactDetail / ProjectDetail 的左侧面板。
 * Props:
 *   collapsed   — 是否折叠
 *   onToggle    — 切换折叠回调
 *   children    — 面板展开时显示的内容
 */
export default function CollapsiblePanel({ collapsed, onToggle, children }) {
  return (
    <div
      className="flex-shrink-0 transition-all duration-300"
      style={{
        width: collapsed ? 48 : 320,
        background: '#1a1a2e',
        minHeight: 'calc(100vh - 160px)',
      }}
    >
      {/* Toggle */}
      <div className="flex items-center justify-end p-2">
        <button
          onClick={onToggle}
          className="text-white/40 hover:text-white/80 transition-colors text-xs"
        >
          {collapsed ? '▶' : '◀'}
        </button>
      </div>

      {!collapsed && (
        <div className="px-4 pb-6 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 200px)' }}>
          {children}
        </div>
      )}
    </div>
  );
}
